import React from 'react';
const SettlementFilterDropdown = ({ selectedFilter, onChange }) => {
  const options = ['All', 'First Settlement', 'Last Settlement'];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
      <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
        Settlement Filter
      </label>
      <select
        value={selectedFilter}
        onChange={(e) => onChange(e.target.value)}
        style={{
          border: '1px solid #D1D5DB',
          borderRadius: '4px',
          padding: '3px 6px',
          fontSize: '11px',
          backgroundColor: 'white',
          cursor: 'pointer'
        }}
      >
        {options.map(option => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
};
export default SettlementFilterDropdown;